import { useToast } from '@chakra-ui/react';
import Firebase from '../common/libs/firebase';
import { setLogRocketUser } from '../common/libs/logRocketForArticleUpload';
import monitoring from '../common/libs/monitoring';
import { useAppContext } from '../contexts/app';
import useApiClient from './useApiClient';
import useAppRouter from './useAppRouter';
import useIdApiClient from './useIdApiClient';

/**
 * 手動ログアウト実行中フラグ（モジュールスコープ）
 * Firebase signOut → onIdTokenChanged(null) の連鎖による
 * 強制ログアウト処理の誤発動を防止する
 */
let isManualLogout = false;

/**
 * 手動ログアウト実行中かどうかを返す
 */
export function getIsManualLogout() {
  return isManualLogout;
}

export function useLogout() {
  const { apiClient } = useApiClient();
  const { idApiClient } = useIdApiClient();
  const router = useAppRouter();
  const { user } = useAppContext();
  const toast = useToast();

  const logout = async (
    redirectUrl?: string,
    mailAddr?: string,
    accountIntegrationCompleted?: boolean,
    fromService?: string,
    reLogin?: string,
  ) => {
    try {
      let res: Response | null = null;
      if (user) {
        // Slideログアウト
        res = await apiClient('/api/logout', {
          method: 'POST',
        });
      }
      // eslint-disable-next-line no-console
      if (!user || res?.ok) {
        // ID基盤ログアウト
        await idApiClient('logout', {
          method: 'POST',
        });

        // 手動ログアウトフラグを設定
        // Firebase signOut 完了後に発火する onIdTokenChanged(null) による
        // 強制ログアウト処理の誤発動を防止する
        isManualLogout = true;
        setTimeout(() => {
          isManualLogout = false;
        }, 10000);

        // Firebaseログアウト
        Firebase.logout();

        router.pushLogin({
          fromService,
          redirectUrl,
          mailAddr,
          accountIntegrationCompleted,
          reLogin,
        });
        monitoring.setUser();
        setLogRocketUser();
      } else {
        throw new Error();
      }
    } catch (e) {
      toast({
        title: 'ログアウトできませんでした。',
        description: 'しばらく待って再度お試しください。',
        status: 'error',
        isClosable: true,
        variant: 'subtle',
      });
    }
  };

  return {
    logout,
  };
}
